import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../constants/colors';

const Root = styled.div.withConfig({ componentId: 'sc-1ptpbri-0' })`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: center;
`;

type Props = {
  children: any[];
};

const BookCtaContainer = ({ children }: Props) => <Root>{children}</Root>;

export default BookCtaContainer;
